export default {"src":"/_next/static/media/pets.3e4665fe.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};